import { GuidGen, getStoredGuidCheckingOpener } from '../../util/storage';
import { v5 as uuidv5 } from 'uuid';

export const PLAY_GUID_KEY = 'ksdk::common::reporter::playGuid';

/**
 * Get a play guid based on the seed. This function uses sessionStorage to
 * persist the value in the face of refreshes for a given domain.
 * @param seed - for creating repeatable play guids.
 * @returns uuid to use for play session
 */
export default function (seed?: GuidGen, newGuid?: boolean): string {
  return getStoredGuidCheckingOpener(PLAY_GUID_KEY, seed, uuidv5.DNS, newGuid);
}
